import React, { useEffect, useState } from 'react';
import { CircularProgress, Container, Typography, Card, CardContent, Stack, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Pie, Bar } from 'react-chartjs-2';
import adminStatsApi from '../../api/adminStatsApi';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

export default function DashboardAdminDesktop() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());

  const years = [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2];

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await adminStatsApi.getDashboardStats(year);
        setStats(res.data);
        console.log("dati",res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [year]);

  if (loading) return <CircularProgress />;
  if (!stats) return <div>Nessun dato</div>;

  // ========================= KPI Fatturato =========================
  let pagati = 0, verificati = 0, inAttesa = 0;
  stats.andamentoMensile.forEach(r => {
    if(r.statoPagamento === 'PAGATO') pagati += r.totale;
    if(r.statoPagamento === 'VERIFICATO') verificati += r.totale;
    if(r.statoPagamento === 'IN_ATTESA') inAttesa += r.totale;
  });

  // ========================= Andamento mensile =========================
  const monthlyMap = {};
  stats.andamentoMensile.forEach(r => {
    const key = `${r.year}-${r.month}`;
    if (!monthlyMap[key]) {
      monthlyMap[key] = { PAGATO: 0, VERIFICATO: 0, IN_ATTESA: 0, FALLITO: 0 };
    }
    monthlyMap[key][r.statoPagamento] = r.totale;
  });
  const months = Object.keys(monthlyMap);
  const andamentoChart = {
    labels: months,
    datasets: [
      { label: 'Pagato', data: months.map(m => monthlyMap[m].PAGATO), backgroundColor: '#4caf50' },
      { label: 'Verificato', data: months.map(m => monthlyMap[m].VERIFICATO), backgroundColor: '#2196f3' },
      { label: 'In attesa', data: months.map(m => monthlyMap[m].IN_ATTESA), backgroundColor: '#ff9800' },
      { label: 'Fallito', data: months.map(m => monthlyMap[m].FALLITO), backgroundColor: '#f44336' }
    ]
  };

  // ========================= PIE CONTRATTI PER TIPO =========================
  const contrattiPie = {
    labels: stats.distribuzioneContratti.map(c => c.tipoContratto),
    datasets: [{
      data: stats.distribuzioneContratti.map(c => c.numeroContratti),
      backgroundColor: ['#0088FE','#00C49F','#FFBB28','#FF8042']
    }]
  };

  // ========================= PIE FATTURATO PER TIPO =========================
  const fatturatoPie = {
    labels: stats.distribuzioneFatturato.map(f => f.tipoContratto),
    datasets: [{
      data: stats.distribuzioneFatturato.map(f => f.fatturato),
      backgroundColor: ['#4caf50','#2196f3','#ff9800','#9c27b0']
    }]
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 3 }}>Dashboard Commerciale – {year}</Typography>

      {/* Selezione anno */}
      <FormControl sx={{ mb: 3, minWidth: 120 }}>
        <InputLabel>Anno</InputLabel>
        <Select value={year} label="Anno emissione pagamento" onChange={e => setYear(e.target.value)}>
          {years.map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
        </Select>
      </FormControl>

      {/* KPI Fatturato */}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }}>
        <Card><CardContent><Typography>Fatturato Pagati</Typography><Typography variant="h5">{pagati} €</Typography></CardContent></Card>
        <Card><CardContent><Typography>Fatturato Verificati</Typography><Typography variant="h5">{verificati} €</Typography></CardContent></Card>
        <Card><CardContent><Typography>Fatturato In Attesa</Typography><Typography variant="h5">{inAttesa} €</Typography></CardContent></Card>
      </Stack>

      {/* Pie Charts */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} sx={{ mb: 4 }}>
        <Card sx={{ flex: 1 }}><CardContent><Typography>Contratti per Tipologia</Typography><Pie data={contrattiPie} /></CardContent></Card>
        <Card sx={{ flex: 1 }}><CardContent><Typography>Fatturato per Tipologia</Typography><Pie data={fatturatoPie} /></CardContent></Card>
      </Stack>

      {/* Andamento mensile */}
      <Card>
        <CardContent>
          <Typography>Evoluzione Mensile Contratti/Fatturato</Typography>
          <Bar data={andamentoChart} />
        </CardContent>
      </Card>
    </Container>
  );
}